var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.878 18.2917C10.1017 18.3027 4.20006 12.3303 4.20838 4.62209C4.20838 4.1187 4.61646 3.70834 5.11984 3.70834H7.52551C7.9772 3.70834 8.36092 4.04023 8.42724 4.48703C8.58621 5.55787 8.89798 6.60037 9.35309 7.58268L9.44675 7.78484C9.57698 8.06594 9.48871 8.39993 9.23659 8.57997C8.49159 9.11201 8.20687 10.1829 8.78726 11.0186C9.51559 12.0672 10.4337 12.9851 11.4821 13.7131C12.3176 14.2933 13.3884 14.0086 13.9204 13.2637C14.1006 13.0115 14.4348 12.9232 14.716 13.0535L14.9173 13.1467C15.8996 13.6018 16.9422 13.9136 18.0132 14.0725C18.46 14.1388 18.7917 14.5225 18.7917 14.9742V17.3802C18.7917 17.8836 18.3826 18.2917 17.8793 18.2917L17.878 18.2917Z",
    fill: "#79819A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.089398a2a7634160dbb34054a18ab726.svg";
export { ForwardRef as ReactComponent };